import { ListItemIcon, ListItemText, MenuItem, MenuList } from '@mui/material'
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined'
import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../Sidebar'
import { useMixPanel } from '../../../contexts/mixpanel'

interface Props {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const SimulateTournamentReports: FC<Props> = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}) => {
  const intl = useIntl()
  const mxp = useMixPanel()
  const [dateToday] = useState(new Date().toISOString().substr(0, 10))

  return (
    <MenuList disablePadding={true} onClick={toggleDrawerOnMobile}>
      <MenuItem
        key="tournament-reports"
        data-test="simulate_sidebar_menuitem_tournament_reports"
        component={ButtonLink}
        href={`/simulate/tournament-reports?filter[start_date]=${dateToday}&filter[end_date]=${dateToday}`}
        selected={pathname.includes('/simulate/tournament-reports')}
        className={nested}
        onClick={() => {
          mxp.track('Sidebar Menu Item (Tournament Reports)', {
            purpose: 'track clicks of menu elements',
          })
        }}
      >
        <ListItemIcon>
          <EmojiEventsOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({
            id: 'sidebar.simulate.tournament.reports',
          })}
        />
      </MenuItem>
    </MenuList>
  )
}
